export const triggerThemeTransition = (
  e:
    | React.MouseEvent<Element, MouseEvent>
    | React.KeyboardEvent<Element>
    | null,
  updateTheme: () => void,
) => {
  // Fallback for browsers that don't support View Transitions
  if (!document.startViewTransition) {
    updateTheme();
    return;
  }

  // Get click coordinates or center of screen
  const x = (e as React.MouseEvent)?.clientX ?? window.innerWidth / 2;
  const y = (e as React.MouseEvent)?.clientY ?? window.innerHeight / 2;

  const endRadius = Math.hypot(
    Math.max(x, window.innerWidth - x),
    Math.max(y, window.innerHeight - y),
  );

  const transition = document.startViewTransition(() => {
    updateTheme();
  });

  transition.ready.then(() => {
    const clipPath = [
      `circle(0px at ${x}px ${y}px)`,
      `circle(${endRadius}px at ${x}px ${y}px)`,
    ];

    document.documentElement.animate(
      {
        clipPath: clipPath,
      },
      {
        duration: 500,
        easing: "ease-in-out",
        pseudoElement: "::view-transition-new(root)",
      },
    );
  });
};
